const formatSection = (title, fields) => {
  const lines = fields.filter((field) => field.value).map((field) => `${field.label}: ${field.value}`);

  if (lines.length === 0) {
    return '';
  }

  return `${title}\n${lines.join('\n')}`;
};

const formatCareplanResponse = (result) => {
  const generalInformation = result.generalInformation || {};
  const medicalHistory = result.medicalHistory || {};
  const careRoutine = result.careRoutine || {};
  const caregiverRequirements = result.caregiverRequirements || {};

  return [
    formatSection('General Information', [
      {label: 'Client Name', value: generalInformation.clientName},
      {label: 'Address', value: generalInformation.address},
      {label: 'Client Info', value: generalInformation.clientInfo},
      {label: 'Notes', value: generalInformation.notes},
    ]),
    formatSection('Medical History', [
      {label: 'Medications', value: medicalHistory.medications},
      {label: 'Conditions', value: medicalHistory.conditions},
    ]),
    formatSection('Care Routine', [
      {label: 'Client Preferences', value: careRoutine.clientPreferences},
      {label: 'Daily Tasks', value: careRoutine.dailyTasks},
    ]),
    formatSection('Caregiver Requirements', [
      {label: 'Careplan Summary', value: caregiverRequirements.careplanSummary},
      {label: 'Schedule Requirement', value: caregiverRequirements.scheduleRequirement},
      {label: 'Match Difficulty', value: caregiverRequirements.matchDifficulty},
      {
        label: 'Requirement Chips',
        value: caregiverRequirements.caregiverRequirementChips?.join(', '),
      },
    ]),
  ].filter(Boolean).join('\n\n');
};

const formatList = (values) => {
  return (values || []).filter(Boolean).join(', ');
};

const formatWeeklySlots = (weeklySlots) => {
  return (weeklySlots || []).map((slot) => {
    return `${slot.day}: ${slot.startTime} - ${slot.endTime}`;
  }).join('\n');
};

const formatJobResponse = (result) => {
  const description = result.description || {};
  const schedule = result.schedule || {};
  const scheduleDetails = schedule.schedule || {};
  const startDate = result.startDate || {};
  const requirements = result.requirements || {};
  const carePlan = result.carePlan || {};
  const considerations = result.considerations || {};
  const location = result.location || {};

  return [
    formatSection('About This Role', [
      {label: 'Client', value: result.client?.clientName},
      {label: 'Short Description', value: description.short},
      {label: 'Long Description', value: description.long?.blob},
    ]),
    formatSection('Schedule', [
      {label: 'Type', value: schedule.type},
      {label: 'Weekly Slots', value: formatWeeklySlots(scheduleDetails.weeklySlots)},
      {label: 'Timezone', value: scheduleDetails.timezone},
      {label: 'Preferred Days', value: formatList(scheduleDetails.preferredDays)},
      {label: 'Preferred Times', value: formatList(scheduleDetails.preferredTimes)},
      {label: 'Visit Duration', value: scheduleDetails.visitDuration},
      {label: 'Start Date', value: startDate.startTime},
    ]),
    formatSection('Compensation', [
      {label: 'Hourly Rate', value: result.price?.hourlyRate},
    ]),
    formatSection('Location', [
      {label: 'Neighborhood', value: location.neighborhood},
      {label: 'City', value: location.city},
    ]),
    formatSection('Care Needs', [
      {label: 'Care Needs', value: formatList(carePlan.careNeeds)},
    ]),
    formatSection('Requirements', [
      {label: 'Certifications', value: formatList(requirements.certifications)},
      {label: 'At Least One Certifications', value: formatList(requirements.atLeastOneCertifications)},
      {label: 'Nice To Have Certifications', value: formatList(requirements.niceToHaveCertifications)},
      {label: 'Languages', value: formatList(requirements.languages)},
      {label: 'Nice To Have Languages', value: formatList(requirements.niceToHaveLanguages)},
    ]),
    formatSection('Considerations', [
      {label: 'Options', value: formatList(considerations.options)},
      {label: 'Additional Considerations', value: considerations.additionalConsiderations?.blob},
    ]),
    formatSection('Priorities', [
      {label: 'Priorities', value: formatList(result.priorities)},
    ]),
  ].filter(Boolean).join('\n\n');
};

const formatTestResponse = (testResponse) => {
  const result = testResponse?.result;

  if (!result) {
    return '';
  }

  switch (result.outputType) {
    case 'EMAIL':
      return result.content || '';
    case 'SMS':
      return result.message || '';
    case 'TEXT':
      return result.text || '';
    case 'CAREPLAN':
      return formatCareplanResponse(result);
    case 'JOB':
      return formatJobResponse(result);
    default:
      return '';
  }
};

export default formatTestResponse;
